export default {
  parameter: {
    label: '録画パラメータ',
    describe:
      'よく使用するゲーム録画調整パラメータをカスタマイズし、録画プロジェクトの編集効率を向上させます。',
    table: {
      listEmpty: {
        describe:
          'まだ録画パラメータが登録されていません。一般的なパラメータを登録して、新しい録画プロジェクトの作成時に再利用できるようにしてください。',
        create: '今すぐ作成を開始しましょう！',
      },
      batch: {
        delete: '{num}個の録画パラメータを削除',
        delete1: 'この録画パラメータを削除しますか？',
        describe:
          'パラメータの削除後、録画プロジェクトには影響しませんが、パラメータは復元できません。削除しますか？',
      },
      isRealized: 'パラメータのステータス',
      notParameter: '未実装のパラメータは録画編集ページに表示されません',
      implemented: '実装済み',
      noImplemented: '未実装',
      isDelete:
        '未実装のパラメータを削除すると、復元できません。削除しますか？',
      minValue: '最小値',
      maxValue: '最大値',
      name: 'パラメータ名',
      operations: '操作',
      note: '説明',
      type: 'パラメータタイプ',
      content: 'オプション値',
      defaults: 'デフォルト値',
      updatetime: '更新時間',
      operation: {
        edittips: '編集',
        copytips: 'コピー',
        deletetips: '削除',
      },
    },
    edit: {
      plementedTips:
        'パラメータを編集した後、プラグイン内でプロジェクト情報をリフレッシュする必要があります。パラメータの編集が失敗する可能性があります。',
      notModifiable: 'パラメータは実装されており、以下の内容は編集できません',
      table: {
        type: 'パラメータのタイプを選択してください',
        duplicateName: 'パラメータ名は既存のパラメータと重複できません',
        maxInput: '最大{num}文字まで入力',
        correctValue:
          '正しい数値範囲を入力してください。デフォルト値はこの範囲内にしてください',
        sort: '並べ替え',
        content: 'コンテンツ',
        operation: '操作',
        add: 'オプションを追加',
      },
      record: '録画パラメータを編集',
      name: 'パラメータ名',
      note: '説明',
      type: 'パラメータタイプ',
      content: 'オプション値',
      preview: 'プレビュー',
      placeholder: {
        name: 'パラメータ名を入力してください',
        description: '説明を入力してください',
        defaults: 'デフォルト値を入力してください',
      },
    },
    input: {
      tips: '最大{size}を入力してください',
      unlimitedTips: '不限',
      limitTips: '限制',
      small: '小',
      large: '大',
      minValue: '最小値',
      maxValue: '最大値',
    },
    new: '新しい録画パラメータ',
    select: {
      single: 'ラジオボタン',
      checkbox: 'チェックボックス',
      radio: 'ドロップダウンリスト（単一選択）',
      multi: 'ドロップダウンリスト（複数選択）',
      numvalue: '数値',
    },
    filter: {
      placeholder: 'パラメータ名を検索',
    },
    create: {
      new: '新しい録画パラメータ',
      name: 'パラメータ名',
      note: '説明',
      type: 'パラメータタイプ',
    },
  },
}
